import api, { login } from "../api";
import store from "../store";

export const getList= async (controller, queryObject, callBack)=>{
    document.body.className='loading';
    let resp = await api.get(controller, queryObject)
    .then(response=>{
        if (callBack!==undefined){
            callBack(response.data,null);
        }
        document.body.className='';
        return response.data;
    }).catch(error=>{
        if (callBack!==undefined){
            callBack(null,error);
        }
        document.body.className='';
        return null;
    });
    return resp;
}

export default getList;